import { ChevronUp, ChevronDown } from 'lucide-react';
import { cn } from '@/lib/utils';
import { TableHead } from '@/components/ui/table';

interface SortableTableHeaderProps {
  field: string;
  currentSortField?: string;
  currentSortDirection?: 'asc' | 'desc';
  onSort: (field: string) => void;
  children: React.ReactNode;
  /** Forwarded to the underlying TableHead (e.g. column width, text-right). */
  className?: string;
  /** Horizontal alignment of the label + sort chevrons. Defaults to 'left'. */
  align?: 'left' | 'right';
}

export function SortableTableHeader({
  field,
  currentSortField,
  currentSortDirection = 'asc',
  onSort,
  children,
  className,
  align = 'left',
}: SortableTableHeaderProps) {
  const isActive = currentSortField === field;

  return (
    <TableHead className={className}>
      <div className={cn('flex items-center gap-1', align === 'right' && 'justify-end')}>
        <span>{children}</span>
        <div className="flex flex-col">
          <button
            onClick={() => onSort(field)}
            className={`p-0 h-3 ${
              isActive && currentSortDirection === 'asc'
                ? 'text-blue-600'
                : 'text-gray-400 hover:text-gray-600'
            }`}
            aria-label={`Sort by ${field} ascending`}
          >
            <ChevronUp className="h-3 w-3" />
          </button>
          <button
            onClick={() => onSort(field)}
            className={`p-0 h-3 ${
              isActive && currentSortDirection === 'desc'
                ? 'text-blue-600'
                : 'text-gray-400 hover:text-gray-600'
            }`}
            aria-label={`Sort by ${field} descending`}
          >
            <ChevronDown className="h-3 w-3" />
          </button>
        </div>
      </div>
    </TableHead>
  );
}
